<template>
  <el-row type="flex" justify="center">
    <el-col :xs="22" :sm="20" :md="16" :lg="14" :xl="12">
      <LoginBox></LoginBox>
    </el-col>
  </el-row>
</template>

<script>
import LoginBox from '@/views/login/LoginBox.vue';

export default {
  name: "PageLogin",
  components: {LoginBox}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/PageLogin.vue